import { AppBar, createStyles, makeStyles, Theme } from '@material-ui/core';
import { Icon } from 'copilot-design-system';
import React from 'react';

import {
  BANNER_HEIGHT,
  DESKTOP_APP_BAR_HEIGHT,
  MOBILE_APP_BAR_HEIGHT,
} from 'src/constants';
import MenuLogo from 'src/features/drawer/MenuLogo';
import { useDrawerWidth } from 'src/features/drawer/useDrawerWidth';
import { useAppSelector } from 'src/hooks/useStore';

import {
  BreadCrumbBase,
  BreadCrumbBaseProps,
  BreadCrumbItem,
} from './BreadCrumbBase';

interface StyleProps {
  showBanner: boolean;
  drawerWidth: number;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    root: (props) => ({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
      height: DESKTOP_APP_BAR_HEIGHT,
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.palette.background.paper,
      width: `calc(100% - ${props.drawerWidth}px)`,
      paddingLeft: theme.spacing(4.5),
      paddingRight: theme.spacing(4.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
      // Considering the case when banner is visible
      // in that case AppBar should be below the banner
      top: props.showBanner ? BANNER_HEIGHT : 0,

      // mobile styles
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        height: MOBILE_APP_BAR_HEIGHT,
      },
    }),

    titleWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.spacing(1.5),
      overflow: 'hidden',
      paddingRight: theme.spacing(2),
    },
  }),
);

interface Props {
  children: React.ReactNode;
  breadcrumbItems: BreadCrumbItem[];
  breadcrumbProps?: Pick<BreadCrumbBaseProps, 'showOnlyTitleOnMobile'>;
  onMenuButtonClick: () => void;
  showMenuButton?: boolean;
}

export const FormHeaderWrapper: React.FC<Props> = ({
  children,
  breadcrumbItems,
  onMenuButtonClick,
  breadcrumbProps,
  showMenuButton = false,
}) => {
  const drawerWidth = useDrawerWidth();
  const { bannerOptions } = useAppSelector((state) => ({
    bannerOptions: state.ui.bannerOptions,
  }));
  const classes = useStyles({
    showBanner: Boolean(bannerOptions),
    drawerWidth,
  });
  return (
    <AppBar
      elevation={0}
      classes={{
        root: classes.root,
      }}
    >
      <div className={classes.titleWrapper}>
        <MenuLogo
          Icon={
            showMenuButton ? <Icon icon="Menu" /> : <Icon icon="ChevronLeft" />
          }
          menuClickCallback={onMenuButtonClick}
        />
        <BreadCrumbBase items={breadcrumbItems} {...breadcrumbProps} />
      </div>
      {children}
    </AppBar>
  );
};
